
import Vue from 'vue';
import Footer from '@/components/footer.vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(
    'div',
    { staticClass: 'su-navbar' },
    [
      _c(
        'b-navbar',
        { staticClass: 'flex-md-column navbar-dark' },
        [
          _c('b-navbar-brand', { attrs: { href: '/' } }, [
            _c('img', {
              staticClass: 'd-inline-block align-top',
              attrs: { src: '/assets/img/logo.svg', alt: 'Show Up Logo' },
            }),
          ]),
          _c(
            'b-navbar-nav',
            { staticClass: 'flex-column not-toggle-nav-list justify-content-end' },
            [
              _c('b-nav-item', { staticClass: 'exit-button', attrs: { href: '/' } }, [
                _c('i', { staticClass: 'su-icon su-icon-exit' }),
                _vm._v('Exit'),
              ]),
            ],
            1,
          ),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  name: 'SecondaryNavBar',
  props: {},
});
